import moment from 'moment';
import { HttpAdapter } from '../../../config/http/http.adapter';
import { AccountsTableResponse } from '../../../infraestructure/interfaces/accounts-table.interface';
import { handleError } from '../../handle-error/handleError';
import { AccountTableMapper } from '../../../infraestructure/mappers/account-table.mapper';
import { AccountTableEntity } from '../../entities/bank/account-table.entity';

interface Props {
  clientId: string;
  dateFrom: string | Date;
  dateTo: string | Date;
  bankId?: string;
  page: number;
  pageSize: number;
}

const currentDate = moment().format('YYYY-MM-DD');

// Fecha restando 12 meses
const originDate = moment().subtract(12, 'months').format('YYYY-MM-DD');

export const AccountsTableUseCases = async (
  fetcher: HttpAdapter,
  props: Props
): Promise<AccountTableEntity> => {
  try {
    const {
      clientId,
      dateFrom = originDate,
      dateTo = currentDate,
      bankId,
      page = 1,
      pageSize = 10,
    } = props;

    const requestData: Record<string, string> = {
      clientId: `${clientId}`,
      dateFrom: `${dateFrom}`,
      dateTo: `${dateTo}`,
    };

    if (bankId) {
      requestData.bankId = `${bankId}`;
    }

    const response = await fetcher.post<AccountsTableResponse>(
      `/data-ms/accounts-table?page=${page}&page-size=${pageSize}`,
      requestData
    );

    return AccountTableMapper.fromResponseToEntity(response);
  } catch (error: any) {
    const processedError = handleError(error);
    console.error('Error procesado:', processedError);
    throw new Error(`${processedError.message} ${processedError.status}`);
  }
};
